import React, { useState } from "react";
import api, { apiError } from "@/lib/api";
import { Panel } from "@/components/common";
import { Input } from "@/components/ui/input";
import { ChatsCircle, PaperPlaneRight, ArrowCounterClockwise } from "@phosphor-icons/react";
import { toast } from "sonner";

export function PracticeChat() {
  const [msgs, setMsgs] = useState([{ role: "agent", text: "Hi, this is Sarah from Asterism Services. Am I speaking with the owner of Sample Trucking LLC?" }]);
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const send = async () => {
    if (!text.trim()) return;
    const next = [...msgs, { role: "carrier", text }];
    setMsgs(next); setText(""); setBusy(true);
    try { const { data } = await api.post("/telecalling/practice", { messages: next }, { timeout: 60000 }); setMsgs([...next, { role: "agent", text: data.reply }]); }
    catch (e) { toast.error(apiError(e.response?.data?.detail)); } finally { setBusy(false); }
  };
  return (
    <Panel className="p-5" data-testid="tc-practice">
      <div className="flex items-center justify-between"><p className="font-heading font-bold text-slate-900 flex items-center gap-2"><ChatsCircle size={18} className="text-violet-500" />Rehearse with her</p>
        <button onClick={() => setMsgs(msgs.slice(0, 1))} className="text-slate-400 hover:text-slate-700" title="Restart" data-testid="tc-practice-reset"><ArrowCounterClockwise size={15} /></button></div>
      <p className="text-xs text-slate-500 mt-1 mb-3">Play the carrier and throw objections at her. Save first to test your latest training.</p>
      <div className="h-64 overflow-y-auto space-y-2 rounded-xl bg-slate-50 p-3" data-testid="tc-practice-log">
        {msgs.map((m, i) => <div key={i} className={`max-w-[88%] rounded-2xl px-3 py-2 text-[13px] ${m.role === "agent" ? "bg-violet-600 text-white rounded-tl-sm" : "ml-auto bg-white border border-slate-200 text-slate-800 rounded-tr-sm"}`}>{m.text}</div>)}
        {busy && <div className="w-14 rounded-2xl bg-violet-600/80 px-3 py-2 text-white text-xs animate-pulse">• • •</div>}
      </div>
      <div className="mt-2 flex gap-2"><Input value={text} onChange={(e) => setText(e.target.value)} onKeyDown={(e) => e.key === "Enter" && send()} placeholder="Say something as the carrier…" className="bg-white" data-testid="tc-practice-input" />
        <button onClick={send} disabled={busy} className="h-10 w-10 shrink-0 rounded-xl bg-slate-900 text-white grid place-items-center" data-testid="tc-practice-send"><PaperPlaneRight size={16} /></button></div>
    </Panel>
  );
}
